SET_USER_ACCOUNT_PAUSE_FORM_DATA